export const environment = {
  production: false,

  // Auth URLs
  loginFlowUrl: '/api/v0/auth/login-flow',
  logoutFlowUrl: '/api/v0/auth/logout',

  // API Endpoints
  apiUrl: '/api/graphql/',

  // Tus server endpoint
  tusEndpoint: '/api/tus',
};
